package ai.jessie.web.members

import ai.jessie.shared.members.InvitationEmailResponse
import ai.jessie.shared.members.MemberResponse
import ai.jessie.web.onboarding.roleLabel
import kotlin.js.Date

internal fun MemberChange.confirmationText() =
    when (this) {
        is MemberChange.Issue ->
            "$email als ${roleLabel(role)} einladen? Die Einladung ist 30 Tage gültig."
        is MemberChange.Resend ->
            "Einladung an ${invitation.email} erneut senden? Sie ist danach wieder 30 Tage gültig."
        is MemberChange.Revoke ->
            "Einladung an ${invitation.email} widerrufen? Alle Einladungslinks werden ungültig."
        is MemberChange.ChangeRole ->
            "Rolle von ${member.name()} von ${roleLabel(member.role)} zu ${roleLabel(role)} ändern?" +
                member.selfWarning()
        is MemberChange.Remove ->
            "${member.name()} aus der Organisation entfernen? Der Zugriff endet mit der " +
                "nächsten Aktion." +
                member.selfWarning()
    }

private fun MemberResponse.selfWarning() =
    if (self && role == "OWNER") " Du verlierst damit deine Eigentümerrechte." else ""

internal fun MemberChange.confirmLabel() =
    when (this) {
        is MemberChange.Issue -> "Einladen"
        is MemberChange.Resend -> "Erneut senden"
        is MemberChange.Revoke -> "Widerrufen"
        is MemberChange.ChangeRole -> "Rolle ändern"
        is MemberChange.Remove -> "Entfernen"
    }

// Step 9. Issue and resend confirm the stored change only; the email outcome is reported
// separately.
internal fun MemberChange.completedText() =
    when (this) {
        is MemberChange.Issue ->
            "Die Einladung wurde gespeichert. Der E-Mail-Status wird bei der Einladung angezeigt."
        is MemberChange.Resend ->
            "Die Einladung wurde erneuert. Der E-Mail-Status wird bei der Einladung angezeigt."
        is MemberChange.Revoke -> "Die Einladung wurde widerrufen."
        is MemberChange.ChangeRole -> "Die Rolle wurde geändert."
        is MemberChange.Remove -> "Das Mitglied wurde entfernt."
    }

internal fun MemberResponse.name() = displayName ?: email ?: "Mitglied"

internal fun emailOutcomeText(outcome: InvitationEmailResponse?): String {
    val label =
        when (outcome?.outcome) {
            null -> return "E-Mail-Status: keine E-Mail erfasst."
            "PENDING" -> "wartet auf den Versand"
            "ACCEPTED" -> "vom Versanddienst angenommen"
            "DELIVERED" -> "zugestellt"
            "BOUNCED" -> "nicht zustellbar"
            "SUPPRESSED" -> "Versand unterdrückt"
            "PERMANENT_FAILED" -> "Versand fehlgeschlagen"
            "CANCELLED" -> "Versand abgebrochen"
            else -> "unbekannt"
        }
    return "E-Mail-Status: $label" +
        outcome.outcomeAt?.let { " (${localTime(it)})" }.orEmpty() +
        "."
}

// Instants are opaque tokens for requests; this is display only.
internal fun localTime(instant: String): String {
    val date = Date(instant)
    return if (date.getTime().isNaN()) instant else date.toLocaleString("de-CH")
}
